/**
 * Base Domain Event for GTD productivity domain
 * Following Eric Evans event sourcing patterns
 */
export abstract class DomainEvent {
  public readonly occurredOn: Date;
  public readonly eventId: string;

  constructor(
    public readonly aggregateId: string,
    public readonly eventType: string,
    public readonly eventVersion: number = 1
  ) {
    this.occurredOn = new Date();
    this.eventId = `${eventType}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }

  abstract getEventData(): Record<string, any>;
}